import { TableColumn } from "../table/TableColumn";

const PresetActionColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "settingType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    }
];

export default PresetActionColumns;
